/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DialogRef, DialogService } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import {
  AuthenticationService,
  Reservation,
  User,
  UsersApiService,
  Vehicle,
  ReservationsApiService,
  Profile,
} from 'rest-client';
import { from, Observable } from 'rxjs';

import { ReservationService } from '@app/modules/core/services/reservation/reservation.service';
import { VehicleService } from '@app/modules/core/services/vehicle/vehicle.service';
import { SetUserAction } from '@app/modules/core/states/auth-state/auth.actions';
import { AuthStateModel } from '@app/modules/core/states/auth-state/auth.model';
import { AuthState } from '@app/modules/core/states/auth-state/auth.state';
import { SetReservationAction } from '@app/modules/core/states/reservation-state/reservation.actions';
import { SetVehicleAction } from '@app/modules/core/states/vehicle-state/vehicle.actions';
import { VehicleState } from '@app/modules/core/states/vehicle-state/vehicle.state';
import { RequestResponse, VehicleData } from '@shared/models';

import { RecoveryPassDialogComponent } from '../recovery-pass-dialog/recovery-pass-dialog.component';

@UntilDestroy()
@Component({
  selector: 'bkg-link-reservation-dialog',
  templateUrl: './link-reservation-dialog.component.html',
  styleUrls: ['./link-reservation-dialog.component.scss'],
})
export class LinkReservationDialogComponent implements OnInit {
  @Select(AuthState.authData) authData$: Observable<AuthStateModel>;
  @Select(VehicleState.vehicle) vehicleData$: Observable<Vehicle>;

  userData: User;

  reservation: Reservation;
  form: FormGroup;
  linkForm: FormGroup;
  errorMessage: string;

  showLinkRegisterForm = false;
  showProfileSelector = false;
  showVehicleSelector = false;
  userVehicles: Vehicle[];
  userProfiles: Profile[];
  loadingVehicles: boolean;
  vehicle: Vehicle;
  linkVehicleCheckbox = false;
  loadingContent: boolean;

  constructor(
    public ref: DialogRef,
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private usersApiService: UsersApiService,
    private store: Store,
    private dialog: DialogService,
    private reservationsApiService: ReservationsApiService,
    private vehicleService: VehicleService,
    private reservationService: ReservationService
  ) { }

  ngOnInit(): void {
    this.reservation = this.ref.data?.reservation as Reservation;
    this.initForm();
    this.subscribeToUserData();
    this.subscribeToVehicleData();

    if (this.logged) {
      this.userProfiles = this.userData?.profiles ? this.userData.profiles : [];
      this.initLinkForm();
      this.getClientVehicles();
    }
  }

  private initForm(): void {
    this.form = this.fb.group({
      password: [null, Validators.required],
    });
  }

  private initLinkForm(): void {
    this.linkForm = this.fb.group({
      vehicle_id: [this.vehicle ? this.vehicle.id : null],
      profile_id: [
        this.reservation.id_invoice_profile
          ? this.reservation.id_invoice_profile
          : null,
      ],
      profileCheckbox: [false],
      import_vehicle: [false],
    });
  }

  onClickLoginLinkReservationBtn(): void {
    const { password } = this.form.value;
    const email = this.reservation.trip.email;
    this.loadingContent = true;
    from(this.authService.login(email, btoa(password)))
      .pipe(untilDestroyed(this))
      .subscribe(
        () => {
          this.loadingContent = false;
          this.onSuccessLogin();
        },
        (err: HttpErrorResponse) => {
          this.onError(err?.error);
          this.loadingContent = false;
        }
      );
  }

  private onSuccessLogin(): void {
    if (this.authService.isTokenValid()) {
      this.usersApiService.getUser().then((user: User) => {
        this.store.dispatch(new SetUserAction(user));
        this.initLinkForm();
        this.userProfiles = user.profiles ? user.profiles : [];
        this.getClientVehicles();
      });
    } else {
      this.errorMessage = 'Invalid token';
    }
  }

  private getClientVehicles = (): void => {
    this.loadingVehicles = true;
    this.vehicleService
      .listClientVehicles()
      .pipe(untilDestroyed(this))
      .subscribe(
        (vehicles: Vehicle[]) => {
          this.userVehicles = vehicles;
          this.selectorsViewer();
        },
        (error: RequestResponse) => {
          this.onError(error);
          this.loadingVehicles = false;
        }
      );
  };

  private selectorsViewer(): void {
    const mo = this.reservation.mechanical_orders?.length;
    const plate = this.reservation.plate;
    const profile = this.reservation.id_invoice_profile;
    const plen = this.userProfiles?.length;
    const vlen = this.userVehicles.length;

    if (plate) this.checkPlateWithUserVehicles();
    if (profile) this.checkInvoiceNifWithUserProfiles();

    if (mo || (!plen && !vlen) || (plate && profile)) {
      if (mo) this.linkForm.controls.import_vehicle.setValue(true);
      return this.onClickRegisterReservationBtn();
    }
    if (this.userVehicles.length && !plate) {
      this.showVehicleSelector = true;
      if (this.reservation.id_vehicle) {
        this.linkVehicleCheckbox = true;
      }
    }

    if (this.userProfiles.length && !profile) {
      this.showProfileSelector = true;
    }
    this.loadingVehicles = false;
    this.showLinkRegisterForm = true;

  }

  onClickRegisterReservationBtn(): void {
    const {
      vehicle_id,
      profile_id,
      profileCheckbox,
      import_vehicle,
    } = this.linkForm.value;
    const params = { vehicle_id, profile_id, import_vehicle };

    if (profileCheckbox) delete params.profile_id;
    if (import_vehicle) params.vehicle_id = this.vehicle.id;

    this.loadingContent = true;

    from(
      this.reservationsApiService.registerReservation(
        this.reservation.id,
        params
      )
    )
      .pipe(untilDestroyed(this))
      .subscribe(
        (reservation: Reservation) => {
          this.getReservation(reservation.id); // needed 'cos Register Reservation doesn't have instructions.
          this.loadingContent = false;
          this.setVehicle(this.reservation.trip.vehicle);
          this.onContinue();
        },
        (err: HttpErrorResponse) => {
          this.loadingContent = false;
          this.onError(err?.error);
        }
      );
  }

  getReservation(reservationId: number): void {
    this.reservationService
      .getReservation(reservationId)
      .subscribe((reservation: Reservation) => {
        this.store.dispatch(new SetReservationAction(reservation));
      });
  }

  navigateToForgetYourPass(): void {
    this.dialog.open(RecoveryPassDialogComponent, {
      closeButton: false,
      size: 'sm',
      backdrop: true,
    });
    this.ref.close(false);
  }

  private onError(error: RequestResponse): void {
    this.errorMessage = error.reason;
  }

  private checkPlateWithUserVehicles(): void {
    const vehicle = this.userVehicles.find(
      (vehicle) => vehicle.plate === this.reservation.plate
    );

    if (vehicle) {
      this.linkForm.controls.vehicle_id.setValue(vehicle.id);
    }
  }

  private checkInvoiceNifWithUserProfiles(): void {
    const profile = this.userProfiles.find(
      (profile) => profile.nif === this.reservation.invoice_nif
    );

    if (profile) {
      this.linkForm.controls.profile_id.setValue(profile.id);
    }
  }

  private setVehicle(vehicle: Vehicle): void {
    if (vehicle) {
      const {
        id,
        vehicle_information,
        km,
        km_timestamp: kmTimestamp,
        workshop_type,
      } = vehicle;

      const vehicleData = {} as VehicleData;
      vehicleData.id = id;
      vehicleData.km = km;
      vehicleData.kmTimestamp = kmTimestamp;
      vehicleData.motorCode =
        vehicle_information?.motor_applicabilitycode ?? null;
      vehicleData.bodyCode = vehicle_information?.body_description ?? null;
      vehicleData.bodyDesc = vehicle_information?.body_description ?? null;
      vehicleData.umc = vehicle_information?.umc ?? null;
      vehicleData.umcData = vehicle_information?.umc_data ?? null;
      vehicleData.workshopType = +workshop_type;
      vehicleData.makeCode = vehicle_information?.make_code ?? null;

      this.store.dispatch(new SetVehicleAction(vehicle, vehicleData));
    }
  }

  private subscribeToUserData(): void {
    this.authData$
      .pipe(untilDestroyed(this))
      .subscribe((authData: AuthStateModel) => {
        this.userData = authData.user;
      });
  }

  private subscribeToVehicleData(): void {
    this.vehicleData$
      .pipe(untilDestroyed(this))
      .subscribe((vehicleData: Vehicle) => (this.vehicle = vehicleData));
  }

  onContinue(): void {
    this.ref.close();
  }

  onCloseBanner(): void {
    this.errorMessage = null;
  }

  onClickClose(): void {
    this.ref.close();
  }

  isValidField(fieldName: string): boolean {
    const control = this.form.get(fieldName);
    return !!control?.valid;
  }

  hasErrors(fieldName: string): boolean {
    const control = this.form.get(fieldName);
    return !!control?.invalid && !!control.touched;
  }

  get isInvalidForm(): boolean {
    return this.form?.invalid;
  }

  get isInvalidLinkForm(): boolean {
    return this.linkForm?.invalid;
  }

  get logged(): boolean {
    return this.authService.isTokenValid();
  }
}
